import * as fromDatatype from "../datatype-library/index";


export interface bl_wms_packing_list_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_guid: fromDatatype.GuidDataFieldInterface;
    wms_item_guid: fromDatatype.GuidDataFieldInterface;
    warehouse_hdr_guid: fromDatatype.GuidDataFieldInterface;
    warehouse_title: fromDatatype.GuidDataFieldInterface;
    fi_item_code: fromDatatype.VarcharDatatypeInterface;
    inv_item_code: fromDatatype.VarcharDatatypeInterface;
    wms_item_code: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    item_uom: fromDatatype.VarcharDatatypeInterface;
    item_qty_base: fromDatatype.NumericDatatypeInterface;
    qty_picked: fromDatatype.NumericDatatypeInterface;
    item_qty_uom: fromDatatype.VarcharDatatypeInterface;
    item_type: fromDatatype.VarcharDatatypeInterface;
    item_sub_type: fromDatatype.VarcharDatatypeInterface;
    packing_running_no: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    container_scan_code : fromDatatype.VarcharDatatypeInterface;
    container_hdr_guid : fromDatatype.GuidDataFieldInterface;
    container_code : fromDatatype.VarcharDatatypeInterface;
    packing_status : fromDatatype.VarcharDatatypeInterface;
    sequence_no : fromDatatype.NumericDatatypeInterface;
    scan_time : fromDatatype.TimestampTzDatatypeInterface;
    gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
}


export class bl_wms_packing_list_line_RowClass
    implements bl_wms_packing_list_line_RowInterface {
        guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_guid: fromDatatype.GuidDataFieldInterface;
    wms_item_guid: fromDatatype.GuidDataFieldInterface;
    warehouse_hdr_guid: fromDatatype.GuidDataFieldInterface;
    warehouse_title: fromDatatype.GuidDataFieldInterface;
    fi_item_code: fromDatatype.VarcharDatatypeInterface;
    inv_item_code: fromDatatype.VarcharDatatypeInterface;
    wms_item_code: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    item_uom: fromDatatype.VarcharDatatypeInterface;
    item_qty_base: fromDatatype.NumericDatatypeInterface;
    qty_picked: fromDatatype.NumericDatatypeInterface;
    item_qty_uom: fromDatatype.VarcharDatatypeInterface;
    item_type: fromDatatype.VarcharDatatypeInterface;
    item_sub_type: fromDatatype.VarcharDatatypeInterface;
    packing_running_no: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    container_scan_code : fromDatatype.VarcharDatatypeInterface;
    container_hdr_guid : fromDatatype.GuidDataFieldInterface;
    container_code : fromDatatype.VarcharDatatypeInterface;
    packing_status : fromDatatype.VarcharDatatypeInterface;
    sequence_no : fromDatatype.NumericDatatypeInterface;
    scan_time : fromDatatype.TimestampTzDatatypeInterface;
    gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
}